export type EntityFormEnumLike = Record<string, string | number>

export function enumFormOptions<TEnum extends EntityFormEnumLike>(
	enumObject: TEnum,
	enumKey: string,
): Array<{ value: string; label: string }> {
	return Object.values(enumObject).map((value) => ({
		value: String(value),
		label: `enum.${enumKey}.${String(value)}`,
	}))
}
